import sileo from 'sileo';

/*
 * Shareable forms are generic forms that are not tied to a workforce,
 * board or any other record. Anyone with the share link can answer them.
 * Backed by the standalone form resources in bposeats' generic_form app.
 */
const StandaloneFormDocument = new sileo.Model('generic_form', 'standalone-form-document');
const PublicStandaloneForm = new sileo.Model('generic_form', 'public-standalone-form');
const StandaloneFormSubmission = new sileo.Model('generic_form', 'standalone-form-submission');
const AnsweredStandaloneForm = new sileo.Model('generic_form', 'answered-standalone-form');

function toFormData(data) {
    const payload = new FormData();
    for (const [key, value] of Object.entries(data)) {
        if (value === undefined) continue;
        payload.append(
            key,
            value !== null && typeof value === 'object' ? JSON.stringify(value) : value
        );
    }
    return payload;
}

const actions = {
    fetchShareableForms(_, filters) {
        return StandaloneFormDocument.objects.filter(filters);
    },

    getShareableForm(_, pk) {
        return StandaloneFormDocument.objects.get(pk);
    },

    createShareableForm(_, data) {
        return StandaloneFormDocument.objects.create(toFormData(data));
    },

    updateShareableForm(_, { pk, ...data }) {
        return StandaloneFormDocument.objects.update({ pk }, toFormData(data));
    },

    deleteShareableForm(_, pk) {
        return StandaloneFormDocument.objects.delete({ pk });
    },

    getPublicShareableForm(_, shareCode) {
        return PublicStandaloneForm.objects.filter({ share_code: shareCode });
    },

    submitShareableFormResponse(_, { document, responses }) {
        return StandaloneFormSubmission.objects.create(toFormData({ document, responses }));
    },

    fetchShareableFormSubmissions(_, filters) {
        return StandaloneFormSubmission.objects.filter(filters);
    },

    // A form the signed-in user answered, with their own submissions
    getAnsweredShareableForm(_, pk) {
        return AnsweredStandaloneForm.objects.get(pk);
    },
};

export default {
    namespaced: true,
    actions,
};
